import { ReactElement } from 'react';

import classNames from 'classnames';

import { PAGINATION_CLASS } from '../../utils/constants';
import ChevronLeft from '../Icon/components/ChevronLeft';
import ChevronRight from '../Icon/components/ChevronRight';
import enGB from './data/en_GB';
import * as Styled from './Pagination.styles';
import { IPaginationProps } from './Pagination.types';

const Pagination = ({ className, size = 'medium', position = 'center', ...rest }: IPaginationProps): ReactElement => (
  <Styled.Pagination
    prefixCls={PAGINATION_CLASS}
    className={classNames(PAGINATION_CLASS, className)}
    prevIcon={<ChevronLeft />}
    nextIcon={<ChevronRight />}
    locale={enGB}
    position={position}
    size={size}
    {...rest}
  />
);

export default Pagination;
